// export const isIOS = /iPhone|iPad|iPod/i.test(window.navigator.userAgent);
export const isIOS = /android|ipod|ipad|iphone|macintosh/.test(window.navigator.userAgent.toLowerCase()) && 'ontouchend' in document;
export const isAndroid = /Android/i.test(window.navigator.userAgent);
export const isMobile = isIOS || isAndroid;
export const isIE = /MSIE|Trident/.test(window.navigator.userAgent);